<template>
  <toggleable-menu ref="menu"
                   class="avviso-menu"
                   min-width="400px" max-width="400px" z-index="9"
                   origin="top left" offset-x auto-x-position>

    <v-form slot="data" slot-scope="{ data }" ref="form" v-model="valid" lazy-validation @submit.prevent="validateForm" :id="'form-avviso' + _uid">
      <v-container grid-list-lg class="px-2 pb-0">

        <v-tooltip bottom>
          <v-btn v-if="edit && !$store.getters.isAbbonamentoExpired" class="btn__delete" slot="activator" icon flat @click="onDeleteClick">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <span>{{ $t('avvisi.azioni.elimina') }}</span>
        </v-tooltip>

        <v-layout wrap row justify-space-between>

          <v-flex xs12 class="mt-2 mb-2 pl-5">
            <span class="title">{{ edit ? $t('avvisi.azioni.modifica') : $t('avvisi.azioni.nuovo') }}</span>
          </v-flex>

          <v-flex xs12>
            <date-picker v-model="form.data_avviso" :label="$t('label.data')" prepend-icon="event" required  :locale="$i18n.locale"
                         menu-right solo flat :clearable="false" class="input--dense" background-color="rgba(0, 0, 0, 0.06)"/>
          </v-flex>

          <v-flex xs9>
            <time-picker v-model="form.ora_avviso" :label="$t('label.ora')" prepend-icon="schedule" required
                         menu-right solo flat :clearable="false" class="input--dense" background-color="rgba(0, 0, 0, 0.06)"/>
          </v-flex>

          <v-flex xs3>
            <selector v-model="form.colore" :items="colors" required
                      solo flat :clearable="false" class="input--dense" background-color="rgba(0, 0, 0, 0.06)">

              <template slot="item" slot-scope="{ item }">
                <v-list-tile-avatar size="26px" :color="'gradient-' + item"/>
              </template>

              <template slot="selection" slot-scope="{ item }">
                <v-list-tile-avatar size="26px" :color="'gradient-' + item"/>
              </template>

            </selector>
          </v-flex>

          <v-flex xs12>
            <v-textarea v-model="form.testo" :label="$t('label.descrizione')" prepend-icon="sort" required
                        auto-grow :rows="3" maxlength="200"
                        :rules="[$utils.rules.required]"
                        solo flat hide-details class="input--dense" background-color="rgba(0, 0, 0, 0.06)"/>
          </v-flex>

          <v-flex xs12 class="py-0 mt-1 v-card__actions">
            <v-spacer/>
            <v-btn v-if="!$store.getters.isAbbonamentoExpired"
                   color="accent" class="ma-0" small
                   :form="'form-avviso' + _uid" type="submit" :disabled="!valid" :loading="sending">
              {{$t('azioni.salva') }}
            </v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>
  </toggleable-menu>
</template>

<script>
import Sendable from '@/mixins/sendable'
import ToggleableMenu from '@/components/base/ToggleableMenu'
import DatePicker from '@/components/inputs/DatePicker'
import TimePicker from '@/components/inputs/TimePicker'
import Selector from '@/components/base/Selector'

export default {
    name: 'AvvisoMenu',
    mixins: [Sendable],
    components: { Selector, DatePicker, TimePicker, ToggleableMenu },
    data () {
        return {
            defaultData: this.$schemas().avviso,
            colors: ['info', 'accent', 'success', 'warning', 'error'],
            valid: true
        }
    },
    methods: {
        action () {
            if (this.edit) {
                return this.$api.avvisi.update(this.form.id, this.form)
            } else {
                return this.$api.avvisi.create(this.form)
            }
        },
        validateForm () {
            if (this.$refs.form.validate()) {
                this.onConfirm()
            }
        },
        onConfirm () {
            this.sending = true
            this.action().then(response => {
                this.onSuccess(this.edit ? this.$t('avvisi.messaggi.modificato') : this.$t('avvisi.messaggi.creato'))
            }).catch(e => {
                this.onError(this.$t('errori.server'))
            })
        },
        onDeleteClick (id) {
            this.$emit('click:delete', this.form.id)
        },
        showCreate (activatorId, avviso = {}) {
            this.edit = false
            avviso.colore = this.colors[0]
            this.initializeForm(avviso)
            this.$refs.menu.show(activatorId, avviso)
        },
        showEdit (activatorId, avviso) {
            this.edit = true
            this.initializeForm(avviso)
            this.$refs.menu.show(activatorId, avviso)
        },
        close () {
            this.$refs.menu.close()
        }
    }
}
</script>
<style lang="scss" scoped>

  .container {
    padding-bottom: 8px !important;

    .btn__delete {
      z-index: 10;
      position: absolute;
      right: 38px;
      top: 0;
    }
  }

  .v-list__tile__avatar {
    min-width: 0 !important;
  }
</style>
